module.exports = __webpack_public_path__ + "static/media/billing_division_logo.64003583.svg";